import http from '../../../utils/http';
import security from '../../../utils/security';
import moment from 'moment';
import {
  REPORT_DEBTS_ERROR,
  REPORT_DEBTS_LOADING,
  REPORT_DEBTS_RESET,
  REPORT_DEBTS_SUCCESS,
} from './mutation-types';

const state = {
  loading: false,
  error: '',
  items: [],
};

function error(error) {
  return {type: REPORT_DEBTS_ERROR, error};
}

function loading(loading) {
  return {type: REPORT_DEBTS_LOADING, loading};
}

function success(items) {
  return {type: REPORT_DEBTS_SUCCESS, items};
}

const getters = {
  error: state => state.error,
  items: state => state.items,
  loading: state => state.loading,
};

const actions = {
  getItems({ commit }, {currency, to}) {
    commit(loading(true));
    commit(error(null));
    to =  moment(to).format('YYYY-MM-DD')
    return http.fetch('/reports/debts/' + currency.id + '?&to=' + to)
      .then(response => response.json())
      .then(data => {
        commit(loading(false));
        commit(success(data));
      })
      .catch(e => {
        commit(loading(false));
        if(security.handleAuthorizationError(e)){
          return;
        }
        commit(error(e.message));
      });
  }
};

const mutations = {
  [REPORT_DEBTS_ERROR] (state, payload) {
    state.error = payload.error;
  },
  [REPORT_DEBTS_LOADING] (state, payload) {
    state.loading = payload.loading;
  },
  [REPORT_DEBTS_SUCCESS] (state, payload) {
    state.items = payload.items;
  },
  [REPORT_DEBTS_RESET] (state) {
    state.items = [];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/report/debts.js